export const getCleanedConnections = action => action.getConnection().updateConnectors(() => null);